interface ServiceCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  features: string[];
}

export function ServiceCard({ icon, title, description, features }: ServiceCardProps) {
  return (
    <div className="group relative bg-white rounded-2xl p-8 shadow-sm border border-neutral-200 hover:border-gold-300 hover:shadow-lg transition-all duration-300">
      {/* Icon */}
      <div className="w-14 h-14 bg-gold-50 rounded-xl flex items-center justify-center mb-6 group-hover:bg-gold-100 transition-colors">
        {icon}
      </div>

      {/* Title */}
      <h3 className="text-xl font-bold text-navy-900 mb-3">{title}</h3>

      {/* Description */}
      <p className="text-neutral-600 mb-6 leading-relaxed">{description}</p>

      {/* Features List */}
      <ul className="space-y-3">
        {features.map((feature, index) => (
          <li key={index} className="flex items-start gap-3">
            <svg className="w-5 h-5 text-gold-500 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
            </svg>
            <span className="text-neutral-600 text-sm">{feature}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
